// removed by extract-text-webpack-plugin
module.exports = {"editor":"styles__editor__OHNS7","container":"styles__container__Wc0rZ","canvas":"styles__canvas__3ni7Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageEditor/styles.scss
// module id = 892
// module chunks = 0